import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssignCaptainsComponent } from './assign-captains.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [AssignCaptainsComponent],
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatRadioModule,
    FormsModule,
    MatIconModule,
    RouterModule,
  ],
})
export class AssignCaptainsModule {}
